var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-computer",
    clipPath: "url(#clip0_2968_4455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.4967 37.4997C44.7884 37.4997 46.6426 35.6247 46.6426 33.333L46.6634 12.4997C46.6634 10.208 44.7884 8.33301 42.4967 8.33301H9.16341C6.87174 8.33301 4.99674 10.208 4.99674 12.4997V33.333C4.99674 35.6247 6.87174 37.4997 9.16341 37.4997H2.91341C1.76758 37.4997 0.830078 38.4372 0.830078 39.583C0.830078 40.7288 1.76758 41.6663 2.91341 41.6663H48.7467C49.8926 41.6663 50.8301 40.7288 50.8301 39.583C50.8301 38.4372 49.8926 37.4997 48.7467 37.4997H42.4967ZM11.2467 12.4997H40.4134C41.5592 12.4997 42.4967 13.4372 42.4967 14.583V31.2497C42.4967 32.3955 41.5592 33.333 40.4134 33.333H11.2467C10.1009 33.333 9.16341 32.3955 9.16341 31.2497V14.583C9.16341 13.4372 10.1009 12.4997 11.2467 12.4997Z",
    fill: "#152344"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2968_4455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.830078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.47cec85b51b68824ced66284b4631069.svg";
export { ForwardRef as ReactComponent };